import { generatePath } from 'react-router-dom';
import { API_URLS } from '../../../routes/urls';
import { getTokenFromStorage, removeTokenFromStorage } from '../../../utils/token';
import { apiSlice } from '../../apiSlice';
import { updateGuestUser } from '../qualification/qualificationSlice';
import {
  GetProfilePayload,
  GetProfileResponse,
  SignInUserWithTokenQueryResponse,
  UserState,
  GetSocialAccountStatusResponse,
  GetSocialAccountStatusPayload,
} from './types';

/**
 * State Management for user profile and login state
 * Also includes student details like education, achivements and so on
 */
export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Get currently logged in student profile
     */
    getProfile: builder.query<UserState, GetProfilePayload>({
      query: ({ slug, userId }) => ({
        url: generatePath(API_URLS.getProfile, { slug }),
        params: {
          user_id: userId,
        },
      }),
      transformResponse(responseData: GetProfileResponse, _meta) {
        return {
          user: responseData.student,
          token: getTokenFromStorage(),
          documentTypes: responseData.documentType,
        };
      },
      providesTags: ['User'],
    }),

    /**
     * Login User with Token
     */
    signInUserWithToken: builder.query<SignInUserWithTokenQueryResponse, string>({
      query: (token) => ({
        url: API_URLS.signInUserWithToken,
        params: {
          token,
        },
      }),
      async onQueryStarted(_args, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          dispatch(updateGuestUser(null));
        } catch (error) {
          removeTokenFromStorage();
        }
      },
    }),

    getSocialAccountStatus: builder.query<GetSocialAccountStatusResponse, GetSocialAccountStatusPayload>({
      query: (params) => ({
        url: API_URLS.socialAccountStatus,
        params: params,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetProfileQuery,
  useGetProfileQuery,
  useSignInUserWithTokenQuery,
  useLazyGetSocialAccountStatusQuery,
} = userApi;
